import axios from 'axios'
import $tool from '@/utils/tool'

const host = process.env.VUE_APP_BASE_API
// 创建axios实例
const request = axios.create({
    // axios中请求配置有baseURL选项，表示请求URL公共部分
    baseURL: host,
    // 超时
    timeout: 30000,
    // 通用请求头
    headers: {
        'Content-Type': 'application/json'
    }
})

// request拦截器
request.interceptors.request.use(config => {
    return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
request.interceptors.response.use(res => {
        return res.data
    },
    error => {
        return Promise.reject(error)
    }
)

// 防抖动
let flag = true

function debounce(msg, dalay, callback) {
    if (flag) {
        flag = false
        setTimeout(() => {
            flag = true
            if (callback) {
                callback()
            }
        }, dalay)
    }
}

function errorHandle(status, withoutToast) {
    switch (status) {
        case 500:
            if (!withoutToast) {
                debounce('服务器错误', 1000)
            }
            break
    }
}

export function get(url, {params, withoutToast, withoutToken, contentType} = {}) {
    const headers = {}
    if (!withoutToken) {
        headers.Authorization = window.localStorage.getItem('token')
    }
    if (contentType) {
        headers['content-type'] = contentType
    }
    return request({
        method: 'GET',
        headers,
        url,
        params
    }).then(res => {
        if (res.errCode === 0) {
            return res
        }
        if (res && !withoutToast) {
            return res
        }
        return Promise.reject(res)
    }, error => {
        const {response} = error
        if (response) {
            // http状态码非200
            errorHandle(response.status, withoutToast)
        } else {
            debounce('请求超时', 1000)
        }
        return Promise.reject(response)
    })
}

export function post(url, {data, withSess,  withoutToast, withoutToken, contentType} = {}) {
    const headers = {}
    if (!withoutToken) {
        headers.Authorization = window.localStorage.getItem('token')
    }
    if (contentType) {
        headers['content-type'] = contentType
    }
    if (withSess) {
        data['session'] = $tool.isLogin()?.session || ''
        data['OCSESSID'] = $tool.isLogin()?.OCSESSID || ''
    }

    return request({
        method: 'POST',
        data: data,
        headers,
        url
    }).then(res => {
        if (res.errCode === 0 || res?.body?.result === 0) {
            return res
        }
        if (res && !withoutToast) {
            return res
        }
        return Promise.reject(res)
    }, error => {
        const {response} = error
        if (response) {
            // http状态码非200
            errorHandle(response.status, withoutToast)
        } else {
            debounce('请求超时', 1000)
        }
        return Promise.reject(response)
    })
}
